import { normalize } from '../../utils';

// get tab containers
const tabContainers = document.querySelectorAll('.js-tab');

// setup tabs
const setupTabs = tabContainer => {
	const tabs = Array.from(tabContainer.querySelectorAll('.js-tab-btn'));
	const items = Array.from(tabContainer.querySelectorAll('.js-tab-content'));

	if (tabs.length === 0 || items.length === 0) return;

	const activateTab = tab => {
		const target = tab.getAttribute('aria-controls');
		const content = document.getElementById(target);
		if (!content) return;

		// toggle button active class
		tabs.forEach(btn => {
			btn.classList.remove('border-orange', 'bg-orange', 'text-cream');
			btn.setAttribute('aria-selected', 'false');
		});
		tab.classList.add('border-orange', 'bg-orange', 'text-cream');
		tab.setAttribute('aria-selected', 'true');

		// toggle content active class
		items.forEach(item => {
			item.classList.remove('is-active');
		});
		content.classList.add('is-active');
	};

	tabs.forEach(tab => {
		tab.onclick = () => activateTab(tab);
	});

	const searchParams = new URLSearchParams(window.location.search);
	const param = normalize(searchParams.get('tab') || '');
	const matchedTab = param
		? tabs.find(tab => {
				const target = normalize(tab.getAttribute('aria-controls'));
				const contentTitle = normalize(
					document.getElementById(tab.getAttribute('aria-controls'))?.dataset.title || ''
				);
				const buttonText = normalize(tab.textContent);
				return param === target || param === contentTitle || param === buttonText;
			})
		: null;

	if (matchedTab) {
		activateTab(matchedTab);
		return;
	}

	activateTab(tabs[0]);
};

const init = () => {
	if (tabContainers.length === 0) return;

	// init tabs
	tabContainers.forEach(tabContainer => {
		// setup tabs
		setupTabs(tabContainer);
	});
};

export default init;
